import { CookieConsentLink } from '@prezly/analytics-nextjs';
import { translations } from '@prezly/theme-kit-intl';
import { useCurrentLocale } from '@prezly/theme-kit-nextjs';
import { useIntl } from 'react-intl';

import { FOOTER_COPY } from '@/utils';

import { DataRequestLink } from './DataRequestLink';

import styles from './Footer.module.scss';

function Footer() {
    const { formatMessage } = useIntl();
    const locale = useCurrentLocale();
    const footerCopy = FOOTER_COPY[locale.toNeutralLanguageCode()];

    return (
        <footer className={styles.container}>
            <div className="container">
                <div className={styles.footer}>
                    <div className={styles.copy}>
                        &copy; {new Date().getFullYear()} Assuralia.{' '}
                        {Boolean(footerCopy) && footerCopy}
                    </div>
                    <div className={styles.links}>
                        <DataRequestLink className={styles.link} />
                        <CookieConsentLink
                            className={styles.link}
                            startUsingCookiesLabel={formatMessage(
                                translations.actions.startUsingCookies,
                            )}
                            stopUsingCookiesLabel={formatMessage(
                                translations.actions.stopUsingCookies,
                            )}
                        />
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
